export default "/profile/images/bitrixUAtwo.png?3a06e5ef82c6b7e6813ef394038537e9";